module.exports = __webpack_public_path__ + "assets/img/logo.a251d4f1.png";